import { useQuery, UseQueryResult } from 'react-query'

import { homeQueries } from 'features/projects/queries'
import { HomeService } from 'features/projects/service'
import { Project } from 'features/projects/types'

function deduplicateProjects(projects: Project[]): Project[] {
  return projects.filter(
    (project, index, self) =>
      index === self.findIndex((p) => p.uuid === project.uuid),
  )
}

export const useProjectSearch = (
  service: HomeService,
  searchType: string,
  debouncedTerm: string,
): UseQueryResult =>
  useQuery({
    ...homeQueries.projectSearch(service, searchType, debouncedTerm),
    select: (data) => ({
      ...data,
      data: deduplicateProjects(data.data),
    }),
  })
